export default __webpack_public_path__ + "static/media/ic_close.553c5821.svg";